import React from "react"
import { loadStripe } from "@stripe/stripe-js"
import styled from "@emotion/styled"

const ButtonStyles = styled.button`
  margin: 10px;
  padding: 20px;
  width: 220px;
  border: none;
  text-align: center;
  font-size: 1.25rem;
  color: #faf2f0;
  position: relative;
  overflow: hidden;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  border-radius: 10px;
  background-color: #100504;

  &:after {
    position: absolute;
    transition: .3s;
    content: '';
    width: 0;
    left: 50%;
    bottom: 0;
    height: 5px;
    background: #d6756c;
  }

  &:hover {
    cursor: pointer;

    &:after {
        width: 100%;
        left: 0;
    }
  }
`

const stripePromise = loadStripe('pk_test_RToycjCR2SJyV9mVY4pOiHq500xPqLycu8');

const redirectToCheckout = async event => {
  event.preventDefault()
  const stripe = await stripePromise
  const { error } = await stripe.redirectToCheckout({
    items: [{ sku: "sku_GtK9jWhEE63Rxr", quantity: 1 }],
    successUrl: `https://me-and-bobbymcgee.netlify.com/success/`,
    cancelUrl: `https://me-and-bobbymcgee.netlify.com/canceled/`,
  })

  if (error) {
    console.warn("Error:", error)
  }
}

const Checkout = () => {
  return (
    <ButtonStyles onClick={redirectToCheckout}>
      Order the Book
    </ButtonStyles>
  )
}

export default Checkout